import {createContext} from 'react';

interface InterceptorType {
  children?: React.ReactNode;
  metaInfo: object;
}

export const InterceptorContext = createContext({});

const Interceptor = (props: InterceptorType) => {
  const {children, metaInfo} = props;

  return (
    <InterceptorContext.Provider value={metaInfo}>
      {children}
    </InterceptorContext.Provider>
  );
};

export {Interceptor};
